import React, { useRef, useState, useCallback } from 'react';
import { Popover, Tappable } from '@vectord/components';
import { useOutsideClick } from '@vectord/hooks';

import CoursePauseLearnerDetailsPopover from '../CoursePauseLearnerDetailsPopover';
import styles from './LearnerInfoPopover.module.scss';

function LearnerInfoPopover({ request }) {
  const popoverRef = useRef(null);
  const learnerInfoRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { mentee } = request;
  const {
    user: { email },
  } = mentee;

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleOutsideClick = useCallback(
    (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        handleClose();
      }
    },
    [handleClose]
  );

  const handleLearnerInfoClick = useCallback(() => {
    setIsOpen(true);
  }, []);

  useOutsideClick(learnerInfoRef, handleOutsideClick);

  return (
    <>
      <Tappable
        noHighlight
        ref={learnerInfoRef}
        className={styles.email}
        onClick={handleLearnerInfoClick}
      >
        {email}
      </Tappable>
      <Popover
        ref={popoverRef}
        anchorRef={learnerInfoRef}
        isOpen={isOpen}
        onClose={handleClose}
      >
        <CoursePauseLearnerDetailsPopover
          handleClose={handleClose}
          request={request}
        />
      </Popover>
    </>
  );
}

export default LearnerInfoPopover;
